<template>
  <warehouse-detail :is-edit='false'>
  </warehouse-detail>
</template>

<script>
import WarehouseDetail from '../components/WarehouseDetail'
export default {
  name: 'CreateWarehouse',
  components: {
    WarehouseDetail
  }
}
</script>

